import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock, ShieldCheck, Sparkles } from "lucide-react";
import BrandLogo from "@/components/Brand";
import { Button } from "@/components/ui/button";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] flex flex-col bg-background">
      <header className="w-full border-b border-border/60">
        <div className="mx-auto max-w-lg px-6 h-16 flex items-center justify-between">
          <BrandLogo variant="dark" className="h-8" />
          <span className="fs-eyebrow text-[10px]">Longevity Check</span>
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-lg px-6 py-10 flex flex-col">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col"
        >
          <p className="fs-eyebrow">FORMAeSALUTE</p>

          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-700 tracking-tight leading-[1.05]">
            Longevity<br />Check
          </h1>

          <p className="mt-5 text-lg text-foreground/80 leading-relaxed">
            Il primo passo per conoscere meglio il tuo punto di partenza e costruire un
            percorso realmente personalizzato.
          </p>

          <p className="mt-4 text-base text-muted-foreground leading-relaxed">
            Il Longevity Test raccoglie alcune informazioni sul tuo stile di vita, sulle tue
            abitudini e sul tuo benessere generale. Le risposte ci aiuteranno a comprendere
            meglio le tue esigenze durante il Longevity Check.
          </p>

          <div className="mt-8 fs-card p-5">
            <ul className="flex flex-col gap-4">
              {[
                { Icon: Clock, t: "Tempo di compilazione", s: "Circa 8–10 minuti" },
                { Icon: ShieldCheck, t: "I tuoi dati sono protetti", s: "Trattati con riservatezza, solo per il tuo percorso" },
                { Icon: Sparkles, t: "Nessun account necessario", s: "Inizia subito dal tuo smartphone" },
              ].map(({ Icon, t, s }) => (
                <li key={t} className="flex items-center gap-3.5">
                  <span className="h-10 w-10 rounded-xl bg-secondary grid place-items-center shrink-0">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <p className="text-sm font-semibold">{t}</p>
                    <p className="text-sm text-muted-foreground">{s}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>

        <div className="flex-1 min-h-8" />

        <div className="mt-8 sticky bottom-6">
          <Button
            data-testid="start-test-btn"
            onClick={() => navigate("/privacy")}
            className="w-full h-14 rounded-full text-base font-semibold group"
          >
            Inizia il Longevity Test
            <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5" />
          </Button>
          <button
            data-testid="staff-access-link"
            onClick={() => navigate("/staff/login")}
            className="mt-5 w-full text-center text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            Area riservata staff
          </button>
        </div>
      </main>
    </div>
  );
}
